import ProgressBarSmall from './component.jsx'
export default ProgressBarSmall
